// App Constants

// Pages that can be accessed without Authentication
export const unprotectedRoutes = ['/404', '/500', '/get-started', '/about'];
